export default __webpack_public_path__ + "static/media/logout.448b9682.png";